import React from "react";
import { Header, Subsection, FooterLinks, DataPageContainer } from "../components";
import data from "../data/future_data.json";
import info from "../data/future_info.json";
import { getContent } from "./Helper";

function FuturePlans() {
  return (
    <DataPageContainer>
      <Header>Future Plans</Header>
      <Subsection> 
        CAD is the currency used in all monetary analysis. 
        We used an exchange rate of 1 USD = 1.3 CAD.
      </Subsection>
      {getContent(info, data)}
      <FooterLinks
        back={{
          text: "view personal development data",
          to: "personal-growth",
        }}
        next={{ text: "view advice & conclusions", to: "advice-conclusions" }}
      />
    </DataPageContainer>
  );
}

export default FuturePlans;
